// import Vue from 'vue'
import App from "./App.vue";
import router from "./router/index";
import Util from "./libs/util";
import appFunction from "./libs/appFunction";

import { post, get } from "./libs/axios";
import store from "./store";
import $ from "jquery";

require("swiper/dist/css/swiper.css");
import "./style/common.scss";

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);
Vue.prototype.util = Util;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.config.productionTip = false;
window.jQuery = $;
window.$ = $;
Util.getUserAgent();
appFunction.getIosToken();
router.beforeEach(async (to, from, next) => {
  //不属于企业微信以及微信
  var ua = sessionStorage.getItem("ua");
  var sUserAgent = navigator.userAgent.toLowerCase();
  if (sUserAgent.indexOf("micromessenger") != -1) {
    ua = "wechat";
  }
  var login = localStorage.getItem("authorization");
  if (to.query.sharecode) {
    sessionStorage.setItem("sharecode", to.query.sharecode);
  }
  if (ua == "wechat") {
    //if(!sessionStorage.getItem('jsapi')){
    await getjsAPI(to);
    //  }
    if (to.meta.login && !login) {
      wechatLogin();
    } else {
      if (
        typeof to.meta.historyHref == "undefined" ||
        to.meta.historyHref == ""
      ) {
        store.commit("addKeep", to.meta.name);
        to.meta.authorization = localStorage.getItem("authorization");
      } else {
        if (to.meta.historyHref != window.location.href) {
          store.commit("minusKeep", to.meta.name);
        } else {
          if (to.meta.authorization != Boolean(login)) {
            store.commit("minusKeep", to.meta.name);
          } else {
            if (from.name == "/login/bindInfo") {
              store.commit("minusKeep", to.meta.name);
            } else {
              store.commit("addKeep", to.meta.name);
            }
          }
        }
      }
      next();
    }
  } else {
    if (to.meta.login && !login) {
      localStorage.setItem("enterUrl", window.location.href);
      next({
        path: "/login/bindInfo",
      });
    } else {
      if (
        typeof to.meta.historyHref == "undefined" ||
        to.meta.historyHref == ""
      ) {
        store.commit("addKeep", to.meta.name);
        to.meta.authorization = login;
      } else {
        if (to.meta.historyHref != window.location.href) {
          store.commit("minusKeep", to.meta.name);
        } else {
          if (to.meta.authorization != Boolean(login)) {
            store.commit("minusKeep", to.meta.name);
          } else {
            if (from.name == "/login/bindInfo") {
              store.commit("minusKeep", to.meta.name);
            } else {
              store.commit("addKeep", to.meta.name);
            }
          }
        }
        // console.log(store.state.state.keepAlive)
      }
      //解决app内部auth注入比页面慢问题
          next();
    }
  }
});
router.afterEach((to, from, next) => {
  var login = localStorage.getItem("authorization");
  setTimeout(function () {
    if (typeof store.state.state.userinfo.customercode == "undefined") {
      if (login) {
        getuserInfo();
      } else {
        store.commit("uploadUserinfo", "");
      }
    }
    if (to.meta.historyHref != window.location.href) {
      if (
        typeof to.meta.historyHref == "undefined" ||
        store.state.state.keepAlive.indexOf(to.meta.name) == -1
      ) {
        window.scrollTo(0, 0);
      }
      store.commit("addKeep", to.meta.name);
    } else {
      if (store.state.state.keepAlive.indexOf(to.meta.name) == -1) {
        window.scrollTo(0, 0);
      }
    }
    to.meta.authorization = Boolean(login);
    to.meta.historyHref = window.location.href;
  });
});

function getjsAPI(to) {
  if (sessionStorage.getItem("jsapiData")) {
    var data = JSON.parse(sessionStorage.getItem("jsapiData"));
    wx.config({
      //调用微信js-sdk
      // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonce, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "chooseWXPay",
        "hideAllNonBaseMenuItem",
        "showAllNonBaseMenuItem",
      ], // 必填，需要使用的JS接口列表
    });
  } else {
    get("https://im.iartschool.com:8443/iart-api-authorize/wx/mp/jsAPI", {
      url: location.href.split("#")[0],
    }).then((res) => {
      if (res.code == 1) {
        var data = res.data;
        sessionStorage.setItem("jsapiData", JSON.stringify(data));
        wx.config({
          //调用微信js-sdk
          //  debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonce, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "chooseWXPay",
            "hideAllNonBaseMenuItem",
            "showAllNonBaseMenuItem",
          ], // 必填，需要使用的JS接口列表
        });
      } else {
        Util.toast({
          msg: res.message,
        });
      }
    });
  }

  setTimeout(function () {
    wx.checkJsApi({
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "chooseWXPay",
        "hideAllNonBaseMenuItem",
        "showAllNonBaseMenuItem",
      ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        if (to.meta.hideShare) {
          wx.hideAllNonBaseMenuItem();
        } else {
          wx.showAllNonBaseMenuItem();
        }
      },
    });
  }, 1000);
}

function getuserInfo() {
  post("iart-api-crm/api/crm/customer/query").then((res) => {
    if (Util.processingData(res)) {
      if (res.code == 1) {
        store.commit("uploadUserinfo", JSON.stringify(res.data));
      } else {
        Util.toast({
          msg: res.message,
        });
      }
    }
  });
}
//添加监听 storage--当在ios以及android内嵌h5时 存入authorization比页面加载慢
/* window.addEventListener('storage', function (event) {
    if(sessionStorage.getItem('ua')=='other'&&event.key=='authorization'){
        location.reload()
    }
}); */
function wechatLogin() {
  if (window.location.host.indexOf("test") != -1) {
    localStorage.setItem("enterUrl", window.location.href);
    router.push({
      path: "/login/bindInfo",
      back: true,
    });
  } else {
    get("iart-api-authorize/wx/authorize/mp", {
      redirect: "http://im.iartschool.com/#/login/bindInfoBoard",
      scope: "snsapi_userinfo",
    })
      .then((res) => {
        localStorage.setItem("enterUrl", window.location.href);
        window.location.href = res.data;
      })
      .catch((res) => {
        //  console.log(res);
      });
  }
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
